import { render, staticRenderFns } from "./fl44-unknown-volume-contract-card.vue?vue&type=template&id=0993cb04&scoped=true&"
import script from "./fl44-unknown-volume-contract-card.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-contract-card.vue?vue&type=script&lang=js&"
import style0 from "./fl44-unknown-volume-contract-card.vue?vue&type=style&index=0&id=0993cb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0993cb04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0993cb04')) {
      api.createRecord('0993cb04', component.options)
    } else {
      api.reload('0993cb04', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-contract-card.vue?vue&type=template&id=0993cb04&scoped=true&", function () {
      api.rerender('0993cb04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-contracts/partials/fl44-unknown-volume-contract-card.vue"
export default component.exports